var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { DetailRowList } from "../..";
let OrderTotalsClass = class OrderTotalsClass extends React.Component {
    render() {
        const { t, tax_in_prices, fees, taxes, discount, total, totalCart, tip } = this.props;
        const promo = this.props.promo; // TODO: Free items promo - to be revised
        const details = [
            {
                l: React.createElement("span", { className: "small" }, t("order.totals.cart")),
                v: React.createElement("span", { className: "small" }, t("currency", { value: totalCart })),
            },
        ];
        if (tip > 0) {
            details.push({
                l: React.createElement("span", { className: "small" }, t("order.totals.tip")),
                v: React.createElement("span", { className: "small" }, t("currency", { value: tip })),
            });
        }
        if (discount > 0 && promo) {
            details.push({
                l: (React.createElement("span", { className: "small" },
                    (!promo.fixed_discount && !promo.percent_discount) && t("order.totals.promo_none", { name: promo.code }),
                    (!!promo.fixed_discount && !!promo.percent_discount) && t("order.totals.promo", { name: promo.code, value: promo.fixed_discount, percent: promo.percent_discount }),
                    (!!promo.fixed_discount && !promo.percent_discount) && t("order.totals.promo_fixed", { name: promo.code }),
                    (!promo.fixed_discount && !!promo.percent_discount) && t("order.totals.promo_percent", { name: promo.code, percent: promo.percent_discount }))),
                v: React.createElement("span", { className: "small" },
                    "-",
                    t("currency", { value: discount })),
            });
        }
        for (const { name, value, fixed_value, percent_value, voided } of fees) {
            details.push({
                l: (() => {
                    if (voided) {
                        return (React.createElement("s", null,
                            React.createElement("span", { className: "small" },
                                (fixed_value === 0 && percent_value === 0) && name,
                                ((fixed_value > 0) && (percent_value > 0)) && t("order.totals.fee", { name: name, value: fixed_value, percent: percent_value }),
                                ((percent_value > 0) && !fixed_value) && t("order.totals.fee_percent", { name: name, percent: percent_value }),
                                ((fixed_value > 0) && !percent_value) && t("order.totals.fee_fixed", { name: name }))));
                    }
                    return (React.createElement("span", { className: "small" },
                        (fixed_value === 0 && percent_value === 0) && name,
                        ((fixed_value > 0) && (percent_value > 0)) && t("order.totals.fee", { name: name, value: fixed_value, percent: percent_value }),
                        ((percent_value > 0) && !fixed_value) && t("order.totals.fee_percent", { name: name, percent: percent_value }),
                        ((fixed_value > 0) && !percent_value) && t("order.totals.fee_fixed", { name: name })));
                })(),
                v: (() => {
                    const d = value === 0 ? t('phrases.free') : t("currency", { value });
                    if (voided) {
                        return React.createElement("s", null,
                            React.createElement("span", { className: "small" }, d));
                    }
                    return React.createElement("span", { className: "small" }, d);
                })(),
            });
        }
        for (const { name, rate, amount } of taxes) {
            details.push({
                l: (React.createElement("span", { className: "small" },
                    !tax_in_prices && t("order.totals.tax", { name: name, percent: rate }),
                    tax_in_prices && t("order.totals.tax_in_prices", { name: name, percent: rate }))),
                v: React.createElement("span", { className: "small" }, t("currency", { value: amount })),
            });
        }
        details.push({
            l: React.createElement("span", { className: "font-bold" }, t("order.totals.total")),
            v: React.createElement("span", { className: "font-bold" }, t("currency", { value: total })),
        });
        return (React.createElement("div", { style: { marginTop: "8px" } },
            React.createElement(DetailRowList, { spacing: 8, items: details })));
    }
};
OrderTotalsClass = __decorate([
    observer
], OrderTotalsClass);
export const OrderTotals = withTranslation()(OrderTotalsClass);
//# sourceMappingURL=order-totals.js.map